import styled from 'styled-components';
import AddCartIcon from '../assets/svg/AddCartIcon';

const Card = styled.div`
  flex-direction: column;
  border-radius: 16px;
  border: 1.5px solid var(--font-color-font-2, #666467);
  background: var(--white-shades-white-100, #fff);
  margin-bottom: 5px;

  img {
    // height: 100%;
  }

  .img-div {
    border-radius: 16px;
    overflow: hidden;
  }

  .content {
    display: flex;
    padding: 1.25rem 1rem 1rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;

    h3 {
      color: var(--font-color-font-1, #1b131f);
      font-family: Instrument Sans;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 26px;
      white-space: nowrap;
      overflow: hidden;
      max-width: 100%;
      text-overflow: ellipsis;
    }

    p {
      font-family: Instrument Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }

    .category {
      color: var(--font-color-font-3, #b4b2b5);
    }

    .description {
      color: var(--font-color-font-2, #666467);
      max-height: 50px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .price {
      color: var(--primary-primary-600-f, #62aa48);
      text-align: center;
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px;
    }
  }
`;

const CatalogCard = ({
  img,
  title,
  category,
  description,
  price,
  imgAlt = '',
}) => {
  return (
    <Card>
      <div className="img-div">
        <img style={{ minHeight: 270 }} src={img} loading="lazy" alt={imgAlt} />
      </div>

      <div className="content">
        <h3 title={title}>{title}</h3>
        <div>
          <p className="category">{category}</p>
          <p className="description" title={description}>
            {description}
          </p>
        </div>
        <div className="d-flex justify-content-between w-100">
          <p className="price">{price}</p>
          <AddCartIcon />
        </div>
      </div>
    </Card>
  );
};

export default CatalogCard;
